export default __webpack_public_path__ + "static/media/cnbc.a070a78d.svg";